var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import BaseTable from '@/components/base/BaseTable.vue';
import TableMixin from '@/mixins/table-mixin';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import { TYPES } from '@/dependency-injection/types';
import { ValidationObserver } from 'vee-validate';
var BolFormatsTable = /** @class */ (function (_super) {
    __extends(BolFormatsTable, _super);
    function BolFormatsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headers = [
            { text: 'ID', value: 'bolFormatId', width: '20%' },
            { text: 'BOL Format', value: 'bolFormat', width: '70%' },
            { text: 'Actions', sortable: false, width: '10%' },
        ];
        return _this;
    }
    BolFormatsTable.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.VendorService;
        this.closeCrudSidesheet();
    };
    BolFormatsTable.prototype.openSidesheet = function (item) {
        var vendorService = this.service;
        // add the contract id to the default pricing formula
        var data = item
            ? __assign({}, item)
            : vendorService.getDefaultBolFormat();
        this.openCrudSidesheetCreate(data);
    };
    Object.defineProperty(BolFormatsTable.prototype, "bolFormats", {
        get: function () {
            var formats = this.item.vendorBolFormats;
            return formats;
        },
        enumerable: false,
        configurable: true
    });
    BolFormatsTable = __decorate([
        Component({
            components: {
                'validation-observer': ValidationObserver,
                'base-table': BaseTable,
            },
        })
    ], BolFormatsTable);
    return BolFormatsTable;
}(Mixins(TableMixin, SteppedPageMixin)));
export default BolFormatsTable;
